import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { getAuthorizedApi, processAxiosError } from "services/common.service";
import DownloadDtoModel from 'models/DownloadDtoModel';
import FileModel from 'models/FileModel';

export const getPdf = createAsyncThunk('pdf/getPdf',
    async ({ fileId, fileName, recordType }: DownloadDtoModel, { dispatch, rejectWithValue }) => {
        try {
            const response = await getAuthorizedApi()
                .get<FileModel[]>(`Pdf/?id=${fileId}&fileName=${fileName}&recordType=${recordType}`);
            return response.data;
        } catch (err) {
            const error = err as AxiosError;
            processAxiosError(error, dispatch);
            return rejectWithValue(error.message);
        }
    });